import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import Flight from '../entities/flight';
import FlightSearchResponse from '../entities/flight/flightSearchResponse';

interface AuxServiceState extends ListState<Flight> {
  select: Flight;
}

class AuxServiceMutations extends ListMutations<Flight> {}

class AuxServiceModule extends ListModule<AuxServiceState, any, Flight> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Flight>(),
    loading: false,
  };
  actions = {
 
    async getAuxiliaryServiceSearch(
      context: ActionContext<AuxServiceState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let response = await Ajax.get(
        '/api/services/app/Flight/AuxiliaryServiceSearch',
        { params: { Id: payload.data } }
      );
      context.state.loading = false;
      context.state.list = response.data.result.flightSearchResponses;
      return response;
      // context.state.totalCount=page.totalCount;
      // context.state.list=page.items;
    },
  };
  mutations = {
    setCurrentPage(state: AuxServiceState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AuxServiceState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const auxServiceModule = new AuxServiceModule();
export default auxServiceModule;
